import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';

const useEditorSidebarShortcuts = ({
    setAnimationsTab,
    setDesignTab,
}: {
    setAnimationsTab?: () => void;
    setDesignTab?: () => void;
}) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e)) {
                return;
            }

            if (e.shiftKey) {
                switch (e.code) {
                    case 'KeyA': {
                        setAnimationsTab && setAnimationsTab();

                        break;
                    }

                    default:
                        break;
                }
            } else {
                switch (e.code) {
                    case 'KeyD': {
                        setDesignTab && setDesignTab();

                        break;
                    }

                    default:
                        break;
                }
            }
        },
        [setAnimationsTab, setDesignTab],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useEditorSidebarShortcuts;
